export const PROTOCOL_HTTP = "http"
export const HOST_API = "https://api.scp.com.co/"
export const PATH_S3_BUCKET = "https://scp-back-static.s3.amazonaws.com"
export const DEFAULT_AVATAR_IMAGE = '../../../public/avatar.png';
export const HOST_API_FEATHER = "https://api.scp.com.co";
export const BUCKET = 'scp-back-static';

// export const signingUrl ='s3-file-uploader'